import { useQuery } from '@tanstack/react-query';

import { api } from '../api';

/** Fallback shape from docs/03 §2 `GET /sessions/:sid/qr`, used before/without the API answer. */
export const GUEST_URL = 'https://app.acapella.lol/guest';

export function guestJoinUrl(joinCode: string | null | undefined): string {
  return joinCode ? `${GUEST_URL}?code=${encodeURIComponent(joinCode)}` : GUEST_URL;
}

/**
 * The join URL behind the queue drawer's QR button. `GET /sessions/:sid/qr` is the source of truth
 * (it is cached server-side until the session expires), but the QR itself is rendered locally
 * from `joinUrl` with the design-system `QrCode`, so a failed call still shows a scannable
 * code built from the live `meta.joinCode`.
 */
export function useJoinQr(sid: string | null, joinCode: string | null | undefined): string {
  const query = useQuery({
    queryKey: ['sessionQr', sid],
    queryFn: () => api.sessionQr({ params: { sid: sid! } }),
    enabled: Boolean(sid),
    staleTime: Infinity,
    retry: false,
  });
  return query.data?.joinUrl ?? guestJoinUrl(joinCode);
}
